import { MissingDataSource } from 'components/helpers/EditingHelpText';
import Container from 'components/helpers/Container';
import { TransplantTotals, ProgramType } from './_types';
import { TcDirectoryListingProps } from '../_types';
import TransplantsContentBlockContainer from './_transplantsContentBlockContainer';

const hasDataToShow = (totals: TransplantTotals) =>
  Array.from(Object.values(totals)).findIndex((x) => x > 0) !== -1;

const NumberOfTransplantsTab = ({ fields }: TcDirectoryListingProps): React.JSX.Element => {
  if (!fields || !fields.totals || !fields.listing || !fields.totals?.fields) {
    return <MissingDataSource />;
  }
  const { listing } = fields;
  const { fields: totalsFields } = fields.totals;

  const { programType } = listing;
  const adultTxFlag = programType?.displayName === 'Both' || programType?.displayName === 'Adult';
  const pedTxFlag = programType?.displayName === 'Both' || programType?.displayName === 'Pediatric';

  const txTotals = {
    adult: {
      allogeneic: totalsFields.adultAllogenicTotal.value || 0,
      autologous: totalsFields.autologousAdultTotal.value || 0,
      cordBlood: totalsFields.adultCordBloodTotal.value || 0,
      grandTotal: totalsFields.adultTotal.value || 0,
      related: totalsFields.relatedAdultTotal.value || 0,
      relatedMarrow: totalsFields.relatedAdultMarrow.value || 0,
      relatedPbsc: totalsFields.relatedAdultPbsc.value || 0,
      relatedCordBlood: totalsFields.relatedAdultCordBlood.value || 0,
      unrelated: totalsFields.unrelatedAdultTotal.value || 0,
      unrelatedMarrow: totalsFields.unrelatedAdultMarrow.value || 0,
      unrelatedPbsc: totalsFields.unrelatedAdultPbsc.value || 0,
      unrelatedCordBlood: totalsFields.unrelatedAdultCordBlood.value || 0,
    },
    pediatric: {
      allogeneic: totalsFields.pedAllogenicTotal.value || 0,
      autologous: totalsFields.autologousPediatricTotal.value || 0,
      cordBlood: totalsFields.pedCordBloodTotal.value || 0,
      grandTotal: totalsFields.pedTotal.value || 0,
      related: totalsFields.relatedPedTotal.value || 0,
      relatedMarrow: totalsFields.relatedPedMarrow.value || 0,
      relatedPbsc: totalsFields.relatedPedPbsc.value || 0,
      relatedCordBlood: totalsFields.relatedPedCordBlood.value || 0,
      unrelated: totalsFields.unrelatedPedTotal.value || 0,
      unrelatedMarrow: totalsFields.unrelatedPedMarrow.value || 0,
      unrelatedPbsc: totalsFields.unrelatedPedPbsc.value || 0,
      unrelatedCordBlood: totalsFields.unrelatedPedCordBlood.value || 0,
    },
  };
  const totalsTables: Array<{ total: number; program: ProgramType }> = [];

  if (adultTxFlag || hasDataToShow(txTotals.adult)) {
    totalsTables.push({
      program: 'adult',
      total: txTotals.adult.grandTotal,
    });
  }
  if (pedTxFlag || hasDataToShow(txTotals.pediatric)) {
    totalsTables.push({
      program: 'pediatric',
      total: txTotals.pediatric.grandTotal,
    });
  }
  totalsTables.sort((x, y) => (x.total >= y.total ? -1 : 1));

  return (
    <Container size="standard" dataComponent="authorable/nmdpsite/tcdirectory/numberoftransplants">
      {totalsTables.map((item, idx) => (
        <TransplantsContentBlockContainer
          key={item.program}
          program={item.program}
          displayYears={listing.displayYears}
          totals={txTotals}
          index={idx}
          count={totalsTables.length}
        />
      ))}
    </Container>
  );
};

export default NumberOfTransplantsTab;
